/*
Обязательные классы и атрибуты: i-select, i-select__op, _selected, data-value
Опционально можно заменить текст после выбора указав data-replace="По возраст. цены"
-----------------------------------------
События пример:
$(document).on('is:change', '.sorting', function (e, val) {
    console.log(val);
})
-----------------------------------------
Пример:
<div class="i-select sorting">
    <div data-value="new" class="i-select__op">
        По новинкам
    </div>
    <div data-value="new1" class="i-select__op _selected">
        По популярности
    </div>
    <div data-value="new2" class="i-select__op" data-replace="По возраст. цены">
        <span class="i-select__up">По цене</span>
    </div>
    <div data-value="new2" class="i-select__op">
        <span class="i-select__down">По цене</span>
    </div>
</div>
-----------------------------------------
Для позиционирования и кастомизации обернуть в контейнер
*/


(function () {
    
    $.fn.iSelect = function (options) {
        return this.each (function (index) {
            const $select = $ (this);
            const $options = $select.find ('.i-select__op');
            const $selectedItem = $select.find ('._selected');
            const selectedItemText = $selectedItem.data ("replace") ? $selectedItem.data ("replace") : $selectedItem.html ();
            const selectPos = {
                left: $select.offset ().left,
                top: $select.offset ().top
            };
            
            $select.attr ('data-dropdown', 'drop' + index);
            let template = `<input type="hidden" value="${$selectedItem.data ('value')}"><div class="i-select__input"><div class="i-select__input-val">${selectedItemText}</div></div>`;
            
            let dropTemplate = `<div class="i-select__dropdown" id="drop${index}" style="left: ${selectPos.left}px; top: ${selectPos.top}px"><div class="i-select__list">`
            //Срендерим селектбокс
            $options.each (function () {
                const $option = $ (this);
                const option = $option.html ();
                const replace = $option.data ("replace") ? $option.data ("replace") : '';
                const value = $option.data ('value');
                const selectedClass = $option.hasClass ('_selected') ? '_selected' : '';
                
                dropTemplate += `<div class="i-select__item ${selectedClass}" data-value="${value}" data-replace="${replace}"><div class="i-select__item-text">${option}</div></div>`
            });
            dropTemplate += `</div></div>`;
            $select.addClass ('_init').html (template);
            $ ("body").append (dropTemplate);
            
            //Init
            const $dropdown = $ ('#drop' + index);
            const $inputVal = $select.find ('.i-select__input-val');
            const $option = $dropdown.find ('.i-select__item');
            const $input = $select.find ('.i-select__input');
            
            //Нажатие на селект
            $input.on ('click', function () {
                $ ('.i-select__dropdown, .i-select').removeClass ('_open');
                $dropdown.css ({
                    left: $select.offset ().left,
                    top: $select.offset ().top
                }).addClass ('_open');
                $select.addClass ('_open');
                //------------------------
                $select.trigger ('is:open');
            });
            
            //Нажатие на пункт
            $option.on ('click', function () {
                const $target = $ (this);
                const $targetVal = $target.find ('.i-select__item-text');
                const text = $target.data ('replace') ? $target.data ('replace') : $targetVal.html ();
                $inputVal.html (text);
                
                if (!$target.hasClass ('_selected')) {
                    $target.addClass ('_selected').siblings ().removeClass ('_selected');
                    $select.find ('input[type=hidden]').val ($target.data ('value'));
                    //------------------------
                    $select.trigger ('is:change', $target.data ('value'));
                }
                
                $dropdown.removeClass ('_open');
                $select.removeClass ('_open');
            });
        });
    };
    
    $ (function () {
        $ (window).on ("resize", function () {
            $ (".i-select__dropdown").each (function () {
                const $dropdown = $ (this);
                const $select = $ ('[data-dropdown=' + $dropdown.attr ('id') + ']');
                $dropdown.css ({
                    left: $select.offset ().left,
                    top: $select.offset ().top
                })
            })
        });
    
        //Outside click
        $ (document).on ("click", function (e) {
            if (!e.target.closest ('.i-select')) {
                $ ('.i-select__dropdown, .i-select').removeClass ('_open');
            }
        });
    
    
        $ (".i-select").each (function () {
            $ (this).iSelect ();
        });
    })
}) ();
